import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

export interface IGlobalTabItem {
    key: string;
    label: React.ReactNode;
    icon?: React.ReactNode;
    children: React.ReactNode;
}

interface IGlobalTabsProps extends Omit<TabsProps, 'items'> {
    items: IGlobalTabItem[];
}

const GlobalTabs: React.FC<IGlobalTabsProps> = ({ items, ...rest }) => {
    const formattedItems: TabsProps['items'] = items.map((item) => ({
        key: item.key,
        label: (
            <span >
                {item.icon}
                {item.label}
            </span>
        ),
        children: item.children,
    }));

    return <Tabs items={formattedItems} {...rest} />;
};

export default GlobalTabs;
